import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const isDeviceDesktop = createSelector(
    appSettingsState,
    appSettings => appSettings?.deviceType === OLO.Enums.DEVICE_TYPE.DESKTOP,
);
